var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-spinner"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }